var arabam;
(function (arabam) {
    var SwapOpsService = /** @class */ (function () {
        function SwapOpsService(CommonHelperService, HttpHelperService, DialogService, $rootScope) {
            this.CommonHelperService = CommonHelperService;
            this.HttpHelperService = HttpHelperService;
            this.DialogService = DialogService;
            this.$rootScope = $rootScope;
            this.selectedSwapCriterias = [];
        }
        SwapOpsService.prototype.init = function (search) {
            var self = this;
            console.log("xxx loaded SwapOpsService");
            this.checkSelectedSwapCriterias(search);
        };
        SwapOpsService.prototype.checkSelectedSwapCriterias = function (searchQuery) {
            var _this = this;
            var searchParams = {};
            this.HttpHelperService.httpGet("/search/selectedSwapCriterias" + searchQuery, function (res) {
                _this.parseSwapFromValidation(res);
            });
            // searchQuery.substr(1).split("&").forEach(pair => {
            //     let k3y = pair.split("=")[0];
            //     let valu3 = pair.split("=")[1];
            //     searchParams[k3y].push(valu3);
            // });
            // this.searchParams = searchParams;
        };
        SwapOpsService.prototype.openSwapPopup = function () {
            var _this = this;
            console.log(this.selectedSwapCriterias);
            this.DialogService.callSwapFilter({
                swapInitiator: (this.selectedSwapCriterias || null),
                takasFacetContainer: this.swapInitiatorFacade
            }).then(function (swapProps) {
                if (typeof swapProps == "string") {
                    return;
                }
                _this.swapInitiator = swapProps.reqObj;
                _this.swapInitiatorFacade = swapProps.takasFacetContainer;
                _this.parseSwapFromDialog(swapProps.reqObj);
            }).catch(function (err) {
                _this.DialogService.warning({ error: err.Message || err });
            });
        };
        SwapOpsService.prototype.parseSwapFromDialog = function (selectedWrapper) {
            var selectedArr = !!selectedWrapper && selectedWrapper.QueryAsStr[0];
            if (selectedArr.length == 0) {
                this.selectedSwapCriterias = null;
                return;
            }
            this.selectedSwapCriterias = [];
            for (var i = selectedArr.length - 1; i >= 0; i--) {
                var item = JSON.parse(selectedArr[i]);
                for (var key in item) {
                    if (item.hasOwnProperty(key)) {
                        // let propName = (""+key).toLowerCase();
                        var propName = "" + key;
                        var propValue = item[key];
                        if (propName.toLowerCase() == "mobileproperties") {
                            propName = propValue[0].Key;
                            var tmpVal = propValue[0].Value[0];
                            propValue = this.CommonHelperService.isDigit(tmpVal) ? tmpVal : this.CommonHelperService.toFriendlyUrl(tmpVal);
                        }
                        if (propName.toLowerCase() == "city" || propName.toLowerCase() == "category") {
                            propValue = (this.CommonHelperService.isDigit(propValue) && typeof propValue != "object") ? propValue : propValue[0];
                        }
                        if (this.selectedSwapCriterias.length == 0 || this.CommonHelperService.findInArray(this.selectedSwapCriterias, "PropertyName", propName) == -1) {
                            var newlyCreatedObj = {
                                PropertyName: propName,
                                Items: [{
                                        Value: propValue
                                    }]
                            };
                            this.selectedSwapCriterias.push(newlyCreatedObj);
                        }
                        else {
                            var propArrIndex = this.CommonHelperService.findInArray(this.selectedSwapCriterias, "PropertyName", propName);
                            var hasBeenSetBefore = !!(this.CommonHelperService.findInArray(this.selectedSwapCriterias[propArrIndex].Items, "Value", propValue) > -1);
                            if (!hasBeenSetBefore) {
                                this.selectedSwapCriterias[propArrIndex].Items.push({
                                    Value: propValue
                                });
                            }
                        }
                    }
                }
                console.log(this.selectedSwapCriterias);
            }
            //TODO: buradaki itemlar eğer ;
            /*
            MobileProperties ise
            swapCriterias.querystring=bodytype~coupe

            //public IList<int> City { get; set; }
            //public IList<int> Category { get; set; }
            //public double? MinPrice { get; set; }
            //public double? MaxPrice { get; set; }
            //public int? MinYear { get; set; }
            //public int? MaxYear { get; set; }
            //public List<KeyValuePair<string,string>> Query { get; set; }
            */
            // searchParams["swapCriterias."+key] = this.CommonHelperService.toFriendlyUrl(item.value);
            this.reWriteUrlBySwap();
        };
        SwapOpsService.prototype.parseSwapFromValidation = function (data) {
            if (!data || (data && data.length == 0)) {
                return false;
            }
            for (var i = data.length - 1; i >= 0; i--) {
                var item = data[i];
                if (this.selectedSwapCriterias.length == 0 || this.CommonHelperService.findInArray(this.selectedSwapCriterias, "PropertyName", item.PropertyName) == -1) {
                    var newlyCreatedObj = {
                        PropertyName: item.PropertyName,
                        Items: [{
                                Value: item.Value,
                                Text: item.Text
                            }]
                    };
                    this.selectedSwapCriterias.push(newlyCreatedObj);
                }
                else {
                    var propArrIndex = this.CommonHelperService.findInArray(this.selectedSwapCriterias, "PropertyName", item.PropertyName);
                    this.selectedSwapCriterias[propArrIndex].Items.push({
                        Value: item.Value,
                        Text: item.Text
                    });
                }
            }
            this.$rootScope.selectedSwapCount = data.length;
            // this.openSwapPopup();
        };
        SwapOpsService.prototype.clearSwapCriteriasFromUrl = function () {
            var newString = "";
            var i = 0;
            var parseQueryString = function () {
                var str = window.location.search;
                var objURL = {};
                str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function ($0, $1, $2, $3) { objURL[$1] = $3; });
                return objURL;
            };
            var params = parseQueryString();
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    if (key.indexOf("swapCriterias") > -1) {
                        delete params["" + key];
                    }
                    else {
                        newString += (i == 0 ? "?" : "&") + key + "=" + params[key];
                        i++;
                    }
                }
            }
            newString = (newString.indexOf("swap=Evet") == -1) ? newString + "&swap=Evet" : newString;
            return newString;
        };
        SwapOpsService.prototype.reWriteUrlBySwap = function () {
            var selectedSwapCriterias = this.selectedSwapCriterias;
            var newSearch = this.clearSwapCriteriasFromUrl();
            var preDefinedKeys = ["city", "category", "minprice", "maxprice", "minyear", "maxyear"];
            var urlConcatenator = "";
            for (var i = selectedSwapCriterias.length - 1; i >= 0; i--) {
                var selectedSwapCriteria = selectedSwapCriterias[i];
                for (var j = selectedSwapCriteria.Items.length - 1; j >= 0; j--) {
                    var selectedSwapCriteriaItem = selectedSwapCriteria.Items[j];
                    if (preDefinedKeys.indexOf(("" + selectedSwapCriteria.PropertyName).toLowerCase()) > -1) {
                        urlConcatenator += "&swapCriterias." + selectedSwapCriteria.PropertyName + "=" + selectedSwapCriteriaItem.Value;
                    }
                    else {
                        urlConcatenator += "&swapCriterias.querystring=" + selectedSwapCriteria.PropertyName + "~" + selectedSwapCriteriaItem.Value;
                    }
                }
            }
            window.location.search = newSearch + urlConcatenator;
        };
        SwapOpsService.$inject = [
            "CommonHelperService",
            "HttpHelperService",
            "DialogService",
            "$rootScope"
        ];
        return SwapOpsService;
    }());
    angular
        .module('arabam')
        .service('SwapOpsService', SwapOpsService);
})(arabam || (arabam = {}));
